(() => {
  'use strict';
  // Portada por ángulo + test en la misma sección (tema alternativo). Sin barra de revisión,
  // sin aislamiento y sin reescritura de enlaces: es la versión de producción del shell.
  const quiz=document.querySelector('[data-cm-quiz-v2-root]');
  const configNode=document.querySelector('script[type="application/json"][id^="cm-qv2-config-"]');
  const entry=document.getElementById('cm-growth-entry');
  if(!quiz||!configNode||!entry||!window.CMGrowthRouting||!window.CMGrowthLanding)return;
  let config={};
  try{config=JSON.parse(configNode.textContent||'{}')||{};}catch{config={};}
  // ?cm_reset=1 (pruebas): borra el recorrido y el ángulo guardados antes de que arranque el test,
  // quita el parámetro de la URL (para que una recarga no vuelva a borrar) y abre la portada del ángulo indicado.
  const reset=new URLSearchParams(location.search).has('cm_reset');
  if(reset){
    try{['cmq_v2_journey_v1','cmq_v2_restore_handoff_v1','cmq_v2_legacy_handoff_v1'].forEach(key=>{localStorage.removeItem(key);sessionStorage.removeItem(key);});sessionStorage.removeItem('cmq_angle');}catch{/* sin almacenamiento */}
    try{const clean=new URL(location.href);clean.searchParams.delete('cm_reset');history.replaceState(history.state,'',clean.toString());}catch{/* sin history */}
  }
  const remembered=(()=>{try{return sessionStorage.getItem('cmq_angle')||'';}catch{return '';}})();
  const route=window.CMGrowthRouting.resolve(location.href,remembered);
  window.CMGrowthLanding.init({config,angle:route.landingAngle});
  // Un enlace de recuperación o un recorrido ya empezado en este navegador abre el test directamente.
  const params=new URLSearchParams(location.search);
  // El enlace de recuperación del plan (email) lleva cm_restore en el hash, no en la query.
  const hashParams=new URLSearchParams(String(location.hash||'').replace(/^#/,''));
  let started=['restore','plan','cm_restore'].some(key=>params.has(key)||hashParams.has(key));
  // El sanitizador de la cabecera del tema ya ha podido mover el código del enlace a sessionStorage
  // (cmq_v2_restore_handoff_v1 / cmq_v2_legacy_handoff_v1) y limpiar la URL antes de llegar aquí.
  if(!started){
    try{started=['cmq_v2_restore_handoff_v1','cmq_v2_legacy_handoff_v1'].some(key=>Boolean(sessionStorage.getItem(key)));}catch{/* sin almacenamiento */}
  }
  if(reset)started=false;
  if(!started){
    try{
      const journey=JSON.parse(localStorage.getItem('cmq_v2_journey_v1')||'null');
      if(journey&&typeof journey.phase==='string'&&journey.phase!=='intro')started=true;
    }catch{/* sin almacenamiento */}
  }
  let pendingStart=false,loadFailed=false,landingSeen=false,startTimer=0;
  const startButtons=[...entry.querySelectorAll('[data-cmg2-start]')];
  const startLabels=new Map(startButtons.map(button=>[button,button.firstChild?.nodeValue]));
  const resultVariant=()=>document.documentElement.classList.contains('cm-review-proposal')?'growth':document.documentElement.classList.contains('cm-review-current')?'current':'';
  function push(event,extra){
    // Entry installs the shared, consent-gated publisher only after assignment and
    // configuration validation. No second analytics channel or pre-consent queue.
    const measurement=window.ChefMiauQuizMeasurement;
    if(!resultVariant()||!measurement||typeof measurement.emit!=='function')return false;
    return measurement.emit(event,extra||{})===true;
  }
  function label(text){for(const button of startButtons){if(button.firstChild&&button.firstChild.nodeType===Node.TEXT_NODE)button.firstChild.nodeValue=text;}}
  function setBusy(busy){
    for(const button of startButtons){button.disabled=busy;button.setAttribute('aria-busy',String(busy));}
    for(const button of startButtons){
      if(button.firstChild&&button.firstChild.nodeType===Node.TEXT_NODE)button.firstChild.nodeValue=busy?'Preparando su plan… ':startLabels.get(button);
    }
  }
  function focusQuiz(){quiz.scrollIntoView({block:'start',behavior:'auto'});const input=quiz.querySelector('input');if(input)input.focus({preventScroll:true});}
  const back=document.createElement('button');back.id='cm-back-context';back.type='button';back.textContent='← Conocer Chef Miau';back.hidden=true;
  quiz.parentElement.insertBefore(back,quiz);
  const isIntro=()=>Boolean(quiz.querySelector('[class*="_introScreen_"]'));
  const isJourney=()=>Boolean(quiz.querySelector('[class*="_questionScreen_"],[class*="_resultScreen_"],[class*="_emailStage_"],[class*="_reviewStage_"],[data-cm-growth-result]'));
  function refresh(){
    if(pendingStart&&quiz.firstElementChild){pendingStart=false;started=true;window.clearTimeout(startTimer);setBusy(false);queueMicrotask(focusQuiz);}
    const intro=isIntro();
    if(isJourney())started=true;
    const open=!started&&(!quiz.firstElementChild||intro);
    document.documentElement.classList.toggle('cm-entry-open',open);
    back.hidden=open||!intro;
    if(open&&!pendingStart&&!landingSeen&&document.visibilityState!=='hidden')landingSeen=push('quiz_landing_view');
  }
  function start(event){
    if(loadFailed){location.reload();return;}
    if(pendingStart||started)return;
    push('quiz_landing_start',{source:(event&&event.detail&&event.detail.source)||'landing'});
    if(!quiz.firstElementChild){
      pendingStart=true;setBusy(true);
      window.clearTimeout(startTimer);
      startTimer=window.setTimeout(()=>{if(!pendingStart)return;pendingStart=false;loadFailed=true;setBusy(false);label('Volver a cargar el test ');},8000);
      return;
    }
    started=true;refresh();focusQuiz();
  }
  window.addEventListener('cm-growth:start',start);
  window.addEventListener('cm-quiz:measurement-ready',refresh);
  // If consent arrives late, record only the landing that is visible now. Never
  // replay a denied click, a previous screen or a hidden-tab exposure.
  document.addEventListener('visitorConsentCollected',()=>queueMicrotask(refresh));
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState!=='hidden')refresh();});
  back.addEventListener('click',()=>{started=false;refresh();window.scrollTo({top:0,behavior:'auto'});const title=document.getElementById('cmg2-title');if(title)title.focus({preventScroll:true});});
  let queued=false;
  new MutationObserver(()=>{if(queued)return;queued=true;queueMicrotask(()=>{queued=false;refresh();});}).observe(quiz,{childList:true,subtree:true});
  refresh();
})();

// Read-only diagnostics for the unpublished integration review. No tracking is sent.
(() => {
  if (new URLSearchParams(location.search).get('cm_qa') !== '1'
    || Number(window.Shopify?.theme?.id) !== 189297164674
    || window.Shopify?.theme?.role !== 'unpublished') return;
/* Read only. Never invokes fbq(), loads a resource, reads cookie values or changes settings. */
function inspectMetaBootstrap(runtime) {
  const f = runtime.fbq, alternate = runtime._fbq;
  const output = {
    metaCallable: typeof f === 'function',
    metaVersionIsBootstrap: Boolean(f && f.version === '2.0'),
    metaVersionLooksLikeSdk: Boolean(f && typeof f.version === 'string' && /^2\.9\.\d+$/.test(f.version)),
    metaSdkExecutionStarted: Boolean(f && typeof f.execStart === 'number'),
    metaCallMethod: Boolean(f && typeof f.callMethod === 'function'),
    metaGetState: Boolean(f && typeof f.getState === 'function'),
    metaExpectedPixelInitialized: false,
    metaExpectedInitQueued: false,
    metaQueuedCommands: 0,
    metaSameAsUnderscore: Boolean(f && f === alternate),
    metaUnderscoreHasSdk: Boolean(alternate && typeof alternate.callMethod === 'function' && typeof alternate.getState === 'function'),
    shopifyMetaAppScriptPresent: false,
    metaSdkScriptCount: 0,
    metaSdkResourceEntryCount: 0,
    metaSdkHttpStatusVisible: false,
    metaSdkReportedHttpFailure: false,
    metaSdkReportedBodyBytes: false,
  };
  try {
    if (f && Array.isArray(f.queue)) {
      output.metaQueuedCommands = f.queue.length;
      output.metaExpectedInitQueued = f.queue.some(command => command && command[0] === 'init' && String(command[1]) === '2341462799686080');
    }
    if (output.metaGetState) {
      const state = f.getState();
      output.metaExpectedPixelInitialized = Boolean(state && Array.isArray(state.pixels) && state.pixels.some(p => p && String(p.id) === '2341462799686080'));
    }
  } catch (_) { /* State inspection never changes runtime behavior. */ }
  function sdkUrl(value) {
    try { const url = new URL(value, runtime.location.href); return url.hostname === 'connect.facebook.net' && url.pathname.endsWith('/fbevents.js'); }
    catch (_) { return false; }
  }
  try {
    for (const script of Array.from(runtime.document.scripts || [])) {
      if (sdkUrl(script.src)) output.metaSdkScriptCount++;
      const url = new URL(script.src || '', runtime.location.href);
      if (url.origin === 'https://chefmiau.com' && url.pathname.includes('/web-pixel-2791801218@')) output.shopifyMetaAppScriptPresent = true;
    }
    for (const resource of runtime.performance.getEntriesByType('resource')) {
      if (!sdkUrl(resource.name)) continue;
      output.metaSdkResourceEntryCount++;
      if (typeof resource.responseStatus === 'number' && resource.responseStatus > 0) output.metaSdkHttpStatusVisible = true;
      if (typeof resource.responseStatus === 'number' && resource.responseStatus >= 400) output.metaSdkReportedHttpFailure = true;
      if (resource.encodedBodySize > 0 || resource.decodedBodySize > 0) output.metaSdkReportedBodyBytes = true;
    }
  } catch (_) { /* Resource timing can be restricted; zero/false is not proof of blocking. */ }
  return output;
}
  const panel=document.createElement('details');
  panel.id='cm-integration-diagnostics';panel.style.cssText='margin:24px;padding:16px;border:1px solid #bbb;background:white;color:#222;font:13px/1.5 monospace';
  const summary=document.createElement('summary');summary.textContent='Comprobación técnica de esta revisión';
  const button=document.createElement('button');button.type='button';button.textContent='Comprobar medición existente';
  const cartButton=document.createElement('button');cartButton.type='button';cartButton.textContent='Comprobar precios del carrito';
  const output=document.createElement('pre');output.style.whiteSpace='pre-wrap';
  panel.append(summary,button,cartButton,output);document.body.appendChild(panel);
  const inspect=async()=>{
    const result={themeId:window.Shopify?.theme?.id,themeRole:window.Shopify?.theme?.role,
      nativeGoogle:typeof window.gtag==='function',nativeMeta:typeof window.fbq==='function',
      shopifyPublisher:typeof window.Shopify?.analytics?.publish==='function',
      analyticsAllowed:window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true,
      marketingAllowed:window.Shopify?.customerPrivacy?.marketingAllowed?.()===true,
      googleClientAvailable:false,googleSessionAvailable:false,
      nativeMeasurement:window.ChefMiauQuizMeasurement?.snapshot?.()??null};
    result.metaInitialization=inspectMetaBootstrap(window);
    if(result.nativeGoogle&&result.analyticsAllowed){
      const get=field=>new Promise(resolve=>{const timer=setTimeout(()=>resolve(false),1200);window.gtag('get','G-JPLEP8CVXH',field,value=>{clearTimeout(timer);resolve(Boolean(value));});});
      [result.googleClientAvailable,result.googleSessionAvailable]=await Promise.all([get('client_id'),get('session_id')]);
    }
    output.textContent=JSON.stringify(result,null,2);
  };
  button.addEventListener('click',inspect);void inspect();
  cartButton.addEventListener('click',async()=>{
    try {
      const response=await fetch('/cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw new Error('No se puede leer el carrito.');
      const cart=await response.json();
      output.textContent=JSON.stringify({total_price:cart.total_price,cart_level_discount_applications:cart.cart_level_discount_applications,
        items:(cart.items||[]).map(item=>({variant_id:item.variant_id,quantity:item.quantity,original_price:item.original_price,original_line_price:item.original_line_price,
          final_price:item.final_price,final_line_price:item.final_line_price,line_price:item.line_price,line_level_total_discount:item.line_level_total_discount,
          discounts:item.discounts,discount_allocations:item.discount_allocations,line_level_discount_allocations:item.line_level_discount_allocations}))},null,2);
    }catch{output.textContent='No se ha podido leer el carrito.';}
  });
})();
